import * as React from 'react'
const SvgComponent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={42} height={28} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M28 9.5h-1.838c-.407.012-.81-.09-1.171-.297a2.45 2.45 0 0 1-.886-.881L21 2h2.318l3.246 2.509h11.927a2.496 2.496 0 1 1 0 4.991H35"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M29.5 8 28 9.5l1.5 1.5H35V8zM41 27H1m2 0V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v23m0-11h6a2 2 0 0 1 2 2v9M8 22h4m-4-5h4m-4-5h4M8 7h4m10.5 15H25m10.035-3.972L37.5 20l2.465-1.972m-4.913 4.013L37.5 24l2.449-1.959M37.5 26.5V16"
    />
  </svg>
)
export default SvgComponent
